

























import { Component, Vue, Prop } from 'vue-property-decorator';
import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn, mdbIcon } from '@folky-tools/mdbvue';

@Component({
    components: {
        mdbModal,
        mdbModalHeader,
        mdbModalTitle,
        mdbModalBody,
        mdbModalFooter,
        mdbBtn,
        mdbIcon
    }
})
export default class FormModal extends Vue {
    @Prop({ type: Boolean, default: false }) private readOnly?: boolean;
    @Prop({ type: Boolean, default: false }) private showModal?: boolean;
    @Prop() private modalTitle?: string;
    @Prop({ type: String, default: 'right' }) private modalPosition?: string;
    @Prop({ type: Boolean, default: false }) private savingData?: boolean;
    @Prop({ type: Boolean, default: false }) private showValidationErrorMessage?: boolean;
    @Prop({ type: String }) private saveButtonText?: string;
    @Prop({ type: String, default: 'save' }) private saveButtonIcon?: string;
    @Prop({ type: Boolean, default: true }) private isFullHeight?: boolean;
    @Prop({ type: String, default: 'md' }) private modalSize?: string;
    @Prop({ type: Boolean, default: false }) private isCentered?: string;
    private defaultSaveButtonText: string = '';

    private saveChanges(): void {
        this.$emit('saveModalChanges');
    }

    private close(): void {
        this.$emit('closeModal');
    }

    private mounted(): void {
        this.defaultSaveButtonText = this.$t('common.actions.doSave').toString();
    }
}
